module.exports = __webpack_public_path__ + "img/97.f9c61311.jpg";